/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */

export function normalizeClassList( classes: null | undefined | string | Array<string> ): string {
	if ( typeof classes === 'string' ) {
		return classes;
	}

	return ( classes ?? [] ).join( ' ' );
}
